import { createAsyncThunk } from '@reduxjs/toolkit';
import api from 'api';
import { AgentRoles } from 'api/models/payload/AgentRoles';
import { Agent } from 'types';

type AgentOption = {
    label: string;
    value: string;
};

export const loadAgents = createAsyncThunk('api/agents/load', async (_, { rejectWithValue }) => {
    try {
        const resp = await api.agents.get(AgentRoles.CONSULTANT);

        const agents: AgentOption[] = resp?.data.map((e: Agent) => ({
            label: [e.firstname, e.middlename, e.lastname].filter(Boolean).join(' '),
            value: e.id.toString(),
        }));

        return agents;
    } catch (error) {
        console.error('Failed to load agents:', error);
        return rejectWithValue('Failed to load agents');
    }
});
